import { BaseService } from './base-service';

class TableService extends BaseService {
  /**
   *  主对象新列表--查询视图以及是否存在分组
   *
   * @author CaoJianBo
   * @param  {integer} entity
   * @param  {integer} viewId
   * @returns
   * @memberof tableService
   */
  getViewAndGroup(params) {
    return this.request({
      method: 'get',
      url: `/dynamicExtend/view/all`,
      params
    });
  }
  /**
   *  主对象新列表--查询某对象视图下字段信息以及是否存在嵌套接口
   *
   * @author CaoJianBo
   * @param  {integer} entity
   * @param  {integer} viewId
   * @returns
   * @memberof tableService
   */
  getFieldAndNest(params) {
    return this.request({
      method: 'get',
      url: `/dynamicExtend/layout/config/listPage`,
      params
    });
  }
  /**
   *  主对象新列表--ListPage接口改造
   *
   * @author CaoJianBo
   * @param  {integer} id
   * @param  {integer} entity
   * @param  {integer} page
   * @param  {integer} pageSize
   * @param  {integer} sceneId
   * @param  {integer} sceneType--0 表示系统，1 表示自定义
   * @param  {Array} conditions
   * @param  {Array} sortSettings
   * @returns
   * @memberof tableService
   */
  getTableDataListPage(data) {
    const request = {
      method: 'post',
      url: `/dynamicExtend/listPage`,
      data
    };
    if (data.apiIndex) {
      request.params = { apiIndex: data?.apiIndex };
    }
    return this.request(request);
  }
  /**
   *  主对象新列表--获取下拉筛选字段和通用按钮
   *
   * @author CaoJianBo
   * @param  {integer} entity
   * @param  {integer} viewId
   * @returns
   * @memberof tableService
   */
  getFilterAndUniversalBtn(params) {
    return this.request({
      method: 'get',
      url: `dynamicExtend/layout/filters/list`,
      params
    });
  }
  /**
   *  主对象新列表--获取批量按钮和快捷按钮
   *
   * @author CaoJianBo
   * @param  {integer} entity
   * @param  {integer} viewId
   * @returns
   * @memberof tableService
   */
  getBatchAndQuickBtn(params) {
    return this.request({
      method: 'get',
      url: `/dynamicExtend/layout/button/list`,
      params
    });
  }
  /**
   *  主对象新列表--获取嵌套字段表头数据
   *
   * @author CaoJianBo
   * @param  {integer} entity
   * @param  {integer} viewId
   * @returns
   * @memberof tableService
   */
  getNestField(params) {
    return this.request({
      method: 'get',
      url: `/dynamicExtend/layout/module/get`,
      params
    });
  }
  /**
   *  主对象新列表分组--groupStructure接口改造
   *
   * @author CaoJianBo
   * @param  {integer} id
   * @param  {integer} entity
   * @param  {integer} page
   * @param  {integer} pageSize
   * @param  {integer} sceneId
   * @param  {integer} sceneType--0 表示系统，1 表示自定义
   * @param  {Array} conditions
   * @param  {Array} sortSettings
   * @returns
   * @memberof tableService
   */
  getGroupStructure(data) {
    return this.request({
      method: 'post',
      url: `/dynamicExtend/groupStructure`,
      data
    });
  }
  /**
   *  分组重构，对groupStructure接口重新改造，获取分组结构
   *
   * @author CaoJianBo
   * @param  {integer} id
   * @param  {integer} entity
   * @param  {integer} page
   * @param  {integer} pageSize
   * @param  {integer} sceneId
   * @param  {integer} sceneType--0 表示系统，1 表示自定义
   * @param  {Array} conditions
   * @param  {Array} groupQuery //分组查询条件, 点击更多时 查询使用
   * @param  {Array} sortSettings
   * @returns
   * @memberof tableService
   */
  getGroupStructureV2(data) {
    return this.request({
      method: 'post',
      url: `/dynamicExtend/v2/groupStructure`,
      data
    });
  }
  /**
   *  主对象新列表--ListPage接口改造--滚动默认加载使用，必须要传递recordIds
   *
   * @author CaoJianBo
   * @param  {integer} id
   * @param  {integer} entity
   * @param  {integer} page
   * @param  {integer} pageSize
   * @param  {integer} sceneId
   * @param  {integer} sceneType--0 表示系统，1 表示自定义
   * @param  {Array} conditions
   * @param  {Array} sortSettings
   * @param  {Array} recordIds //记录id集合,列表分组首屏优化使用
   * @returns
   * @memberof tableService
   */
  getTableDataListPageV2(data) {
    const request = {
      method: 'post',
      url: `/dynamicExtend/listPageByIds`,
      data
    };
    if (data.apiIndex) {
      request.params = { apiIndex: data?.apiIndex };
    }
    return this.request(request);
  }
  /**
   *  主对象新列表--ListPage接口改造--分组列表优化点击"更多"加载使用
   *
   * @author CaoJianBo
   * @param  {integer} id
   * @param  {integer} entity
   * @param  {integer} page
   * @param  {integer} pageSize
   * @param  {integer} sceneId
   * @param  {integer} sceneType--0 表示系统，1 表示自定义
   * @param  {Array} conditions//高级筛选条件
   * @param  {Array} sortSettings
   * @param  {Array} groupQuery //分组查询条件
   * @returns
   * @memberof tableService
   */
  getTableDataListPageClickV2(data) {
    return this.request({
      method: 'post',
      url: `/dynamicExtend/v2/listPage`,
      data
    });
  }
  /**
   *  主对象新列表--设置数据排序
   *
   * @author MaYuhui
   * @param  {object} data
   * @param  {number} data.entity 对象ID
   * @param  {number} data.viewId 视图ID
   * @param  {number[]} data.ids 排序ID数组
   * @param  {number} data.preId 移动位置的前一个ID
   * @param  {number} data.nextId 移动位置的后一个ID
   * @returns {Promise<any>}
   * @memberof tableService
   */
  setDataSort(data) {
    return this.request({
      method: 'post',
      url: `/dynamic/sort`,
      data
    });
  }
}

export const tableService = new TableService();
